import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import CustomTableBackendFilters from "../../../components/CustomTableBackendFilters";

//redux

import { deleteObjectiveMetric, editObjectiveMetric, getObjectiveMetric, resetObjectiveMetric, saveObjectiveMetric } from "../../../redux/evaluacion_desempenio/ObjectiveMetric/actions";
import { getConfSmart } from "../../../redux/evaluacion_desempenio/ConfSmart/actions";



const ObjectiveMetric = (props) => {
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);

  //Variables para filtrado y paginación
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});

  //Variables para editar
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [anio, setAnio] = useState("");
  const [selectedConf, setSelectedConf] = useState(null);

  const yearsOptions = Array.from(
    { length: 5 },
    (_, i) => ({
      id: moment().year() - i,
      label: moment().year() - i
    })
  );

  //Variables para el formulario
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);


  //Redux
  const dispatch = useDispatch();
  const objectiveMetricStore = useSelector(
    (store) => store.objectiveMetric
  );


  const {
    loading,
    objectiveMetrics,
    objectiveMetricsLength,
    objectiveMetricError,
    saveLoading,
    formError,
  } = objectiveMetricStore;

  const {
    loading: loadingConfSmart,
    confSmartsLength,
    confSmarts,
    confSmartError
  } = useSelector((store) => store.confSmart);


  //Esquema de validación
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    descripcion: Yup.string().optional().nullable(true),
    escala: Yup.number().typeError("**Debe ser un número").required("**Campo requerido"),
    rango_minimo: Yup.number().typeError("**Debe ser un número").min(0, "**Mínimo 0").max(Yup.ref("rango_maximo"), "**Máximo debe ser mayor que mínimo").required("**Campo requerido"),
    rango_maximo: Yup.number().typeError("**Debe ser un número").min(Yup.ref("rango_minimo"), "**Máximo debe ser mayor que mínimo").max(120, "**Máximo 120").required("**Campo requerido"),
    escala_competencias_valores: Yup.number().typeError("**Debe ser un número").min(0, "**Mínimo 0").max(120, "**Máximo 120").required("**Campo requerido"),
    peso: Yup.number().typeError("**Debe ser un número").min(0, "**Mínimo 0").max(100, "**Máximo 100").required("**Campo requerido")
  });

  useEffect(() => {
    dispatch(resetObjectiveMetric())
  }, [])

  useEffect(() => {
    if (anio && selectedConf) {
      dispatch(getObjectiveMetric({
        ...filters
      }));
    }
  }, [filters]);


  useEffect(() => {
    if (selectedConf) {
      setFilters({
        ...filters,
        configuracion: selectedConf.id,
      });
    }
  }, [selectedConf])


  useEffect(() => {
    if (anio) {
      dispatch(getConfSmart({
        anio: anio,
        primera_por_grupo: true, // Solo traer la primera configuración de cada grupo para mostrar en el select
      }))

    }
  }, [anio])


  const configOptions = confSmarts?.map((level) => ({
    id: level.id,
    label: level.nombre
  })) || [];



  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre"

    },
    {
      Header: "Descripción",
      accessor: "descripcion"

    },
    {
      Header: "Escala",
      accessor: "escala"

    },
    {
      Header: "Rango mínimo",
      accessor: "rango_minimo"

    },
    {
      Header: "Rango máximo",
      accessor: "rango_maximo"

    },
    {
      Header: "Peso",
      accessor: "peso",

    },
    {
      Header: "Escala competencias valores",
      accessor: "escala_competencias_valores"
    },
    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  //Funciones
  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteObjectiveMetric(id, data));
    }
  };


  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };



  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setOffset(0);
  };

  const onSubmit = (req) => {
    req.configuracion = selectedConf.id;
    if (!edit) {
      dispatch(saveObjectiveMetric(req, setShowFormModal));
    } else {
      dispatch(editObjectiveMetric(req, editItem.id, index, setShowFormModal));
    }
  };


  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              MÉTRICA
            </h5>
            <Form>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                      disabled={!(anio && selectedConf) || loading}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!objectiveMetricError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {objectiveMetricError}
            </Alert>
          )}

          <div>
            <Form>
              <Form.Row className="">
                <Form.Group as={Col} sm={12} md={6} lg={6} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Año
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="anio"
                    className="col rounded-pill"
                    placeholder="Año"
                    value={anio}
                    onChange={(e) => {
                      setSelectedConf(null);
                      setFilters({});
                      setAnio(e.target.value)
                      dispatch(resetObjectiveMetric());
                    }}
                  >
                    <option value="">Seleccione un año</option>
                    {yearsOptions.map((year) => (
                      <option key={year.id} value={year.id}>
                        {year.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                <Form.Group as={Col} sm={12} md={6} lg={6} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Configuración
                  </Form.Label>
                  {
                    <div className="d-flex align-items-center">
                      <Typeahead
                        className="w-100"
                        key={anio}
                        id="configuración"
                        name="configuración"
                        placeholder="Seleccione una configuración"
                        options={configOptions}
                        disabled={loadingConfSmart || !anio}
                        onChange={(selected) => {
                          setSelectedConf(selected[0]);
                        }}
                        defaultInputValue={selectedConf ? selectedConf.label : ""}
                      >
                      </Typeahead>
                      {loadingConfSmart && (
                        <Spinner
                          className="ml-2"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                    </div>
                  }
                </Form.Group>
              </Form.Row>
            </Form>
          </div>

  
          <Card className="border-0">
            <Card.Body className="px-1 px-sm-2">
              <CustomTableBackendFilters
                columns={columns}
                data={objectiveMetrics || []}
                isLoadingData={loading}
                onFiltersChange={handleFiltersChange}
                filters={filters}
              />
            </Card.Body>
          </Card>


        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              nombre: edit ? editItem.nombre : "",
              descripcion: edit ? editItem.descripcion : "",
              escala: edit ? editItem.escala : "",
              rango_minimo: edit ? editItem.rango_minimo : "",
              rango_maximo: edit ? editItem.rango_maximo : "",
              peso: edit ? editItem.peso : "",
              escala_competencias_valores: edit ? editItem.escala_competencias_valores : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit
                      ? "Editar Métrica"
                      : "Crear Métrica"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {formError &&
                    typeof formError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {formError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Nombre
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Nombre"
                      onBlur={handleBlur("nombre")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Descripción
                    </Form.Label>
                    <Form.Control
                      name="descripcion"
                      id="descripcion"
                      className="rounded"
                      as="textarea"
                      value={values.descripcion}
                      placeholder="Descripción"
                      onBlur={handleBlur("descripcion")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.descripcion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.descripcion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Escala
                    </Form.Label>
                    <Form.Control
                      name="escala"
                      className="rounded-pill"
                      required
                      type="number"
                      value={values.escala}
                      placeholder="Escala"
                      onBlur={handleBlur("escala")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.escala && !!errors.escala}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.escala}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.escala ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.escala.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Rango mínimo
                    </Form.Label>
                    <Form.Control
                      name="rango_minimo"
                      className="rounded-pill"
                      required
                      type="number"
                      value={values.rango_minimo}
                      placeholder="Rango mínimo"
                      onBlur={handleBlur("rango_minimo")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.rango_minimo && !!errors.rango_minimo}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.rango_minimo}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.rango_minimo ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.rango_minimo.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Rango máximo
                    </Form.Label>
                    <Form.Control
                      name="rango_maximo"
                      className="rounded-pill"
                      required
                      type="number"
                      value={values.rango_maximo}
                      placeholder="Rango máximo"
                      onBlur={handleBlur("rango_maximo")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.rango_maximo && !!errors.rango_maximo}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.rango_maximo}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.rango_maximo ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.rango_maximo.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Peso
                    </Form.Label>
                    <Form.Control
                      name="peso"
                      className="rounded-pill"
                      required
                      type="number"
                      value={values.peso}
                      placeholder="Peso"
                      onBlur={handleBlur("peso")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.peso && !!errors.peso}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.peso}
                    </Form.Control.Feedback>
                    {formError && typeof formError === "object" && formError.peso ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.peso.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Escala competencias y valores
                    </Form.Label>
                    <Form.Control
                      name="escala_competencias_valores"
                      className="rounded-pill"
                      required
                      type="number"
                      value={values.escala_competencias_valores}
                      placeholder="Escala competencias valores"
                      onBlur={handleBlur("escala_competencias_valores")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.escala_competencias_valores && !!errors.escala_competencias_valores}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.escala_competencias_valores}
                    </Form.Control.Feedback>
                    {formError &&
                      typeof formError === "object" &&
                      formError.escala_competencias_valores ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formError.escala_competencias_valores.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoading}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoading && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default ObjectiveMetric;
